/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903067145 — useTabSync */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { APP_ROUTES, STORAGE_KEYS } from '../constants';
import { clearAllSavedStates } from '../lib/stateStorage';

export const useTabSync = (tabId: string) => {
    const navigate = useNavigate();

    useEffect(() => {
        const onStorageUpdate = (e: StorageEvent) => {
            // Only react to another tab claiming a new TAB_ID, not to a
            // removeItem (newValue=null) — that's a session-wipe from
            // another flow and shouldn't trigger a chain of self-kills.
            if (e.key === STORAGE_KEYS.TAB_ID && e.newValue !== null) {
                if (e.oldValue === tabId) {
                    clearAllSavedStates();
                    navigate(`/${APP_ROUTES.sessionExpired}`, { replace: true });
                }
            }
        };

        window.addEventListener('storage', onStorageUpdate);
        return () => {
            window.removeEventListener('storage', onStorageUpdate);
        };
    }, [tabId, navigate]);
};
